import PosthogService from '~/services/posthog/PosthogService';

// Event-specific interface (co-located)
export interface IInterviewRequestInviteCandidatesAddedPayload {
  postingId: string;
  totalCandidatesSelected: number;
}

/**
 * Fires when the user adds candidates to invite in the interview request flow
 * Event: dental_portal:interview_request:invite_candidates_added
 */
export function fireInterviewRequestInviteCandidatesAdded(
  payload: IInterviewRequestInviteCandidatesAddedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:interview_request:invite_candidates_added', {
    posting_id: payload.postingId,
    total_candidates_selected: payload.totalCandidatesSelected,
  });
}
